import { isEmpty } from "lodash-es";
import { useFeatureFlagVariantKey } from "posthog-js/react";

type UseGetPosthogVariantProps = {
  /** The unique name of the feature flag. */
  flag: string;
  /** Boolean to indicate to enable variant experiment function. Default is false. */
  isEnabledFeatureFlagVariant?: boolean;
};
/**
 * Hook to get PostHog feature flag variant information
 *
 * @returns An object containing:
 * - gaVariant: The full variant key returned by PostHog which include the feature flag. E.g "test-feature_dummy_experiment".
 * - variant: The simplified variant key which remove feature flag default control use in conditional rendering E.g. "new_feature-A" becomes "new_feature".
 *
 * Naming convention:
 * - gaVariant : "variantName-feature_flag_name": Variant when experiment is applied.
 * - variant: "variantName": Variant used for conditional rendering in the app.
 */
export const useGetPosthogVariant = ({
  flag,
  isEnabledFeatureFlagVariant = false,
}: UseGetPosthogVariantProps) => {
  const _flag = isEnabledFeatureFlagVariant ? flag : "";

  const posthogVariant = useFeatureFlagVariantKey(_flag);
  const gaVariant = isEnabledFeatureFlagVariant
    ? posthogVariant?.toString()
    : "";

  const variant =
    typeof posthogVariant === "string" &&
    !isEmpty(posthogVariant) &&
    isEnabledFeatureFlagVariant
      ? posthogVariant.split("-")[0]
      : "control";

  return { gaVariant, variant };
};
